export async function loadIllustrationConfig(illustrations) {
    const config = getIllustrationConfig(await illustrations);
    return {
        layers: await config.layers,
        global: config.global
    };
}
function getIllustrationConfig(illustration) {
    if (isIllustrationConfig(illustration)) {
        return illustration;
    }
    return {
        layers: illustration
    };
}
function isIllustrationConfig(illustration) {
    return !!illustration.layers;
}
const cache = new Map();
export async function loadImage(src) {
    if (cache.has(src)) {
        return await cache.get(src);
    }
    const isBrowser = typeof document !== 'undefined';
    const loading = isBrowser ? loadImageBrowser(src) : loadImageNode(src);
    cache.set(src, loading);
    return await loading;
}
export async function loadImages(imageSrcs) {
    const imagesMap = {};
    await Promise.all(imageSrcs.map(async (src) => {
        const image = await loadImage(src);
        imagesMap[src] = image;
    }));
    return imagesMap;
}
export async function loadLayers(layers) {
    return await Promise.all(layers.map(async (layer) => {
        const { image, ...item } = layer;
        return { ...item, image: await loadImage(image), id: layer.id };
    }));
}
async function loadImageBrowser(src) {
    return new Promise((resolve) => {
        const image = new Image();
        image.crossOrigin = 'Anonymous';
        image.onload = () => resolve(image);
        image.src = src;
    });
}
async function loadImageNode(src) {
    const https = await import('https');
    const { decodePNGFromStream } = await import('pureimage');
    const get = (url) => new Promise((res) => https.get(url, res));
    const imageStream = await get(src);
    return (await decodePNGFromStream(imageStream));
}
